import cancelSaveAttachmentsToCloudOperation from 'owa-service/lib/operation/cancelSaveAttachmentsToCloudOperation';
import type RequestOptions from 'owa-service/lib/RequestOptions';

export default function cancelSaveAttachmentsToCloud(
    itemId: string,
    requestOptions: RequestOptions
): Promise<boolean> {
    return cancelSaveAttachmentsToCloudOperation({ itemId: itemId }, requestOptions);
}
